import { createFileRoute } from '@tanstack/react-router'
import { SchedulePage } from '@/features/schedule/schedule-page'

export const Route = createFileRoute('/_auth/w/$workspaceSlug/schedule')({
  component: ScheduleRoute,
})

function ScheduleRoute() {
  const { workspaceSlug } = Route.useParams()

  return <SchedulePage workspaceSlug={workspaceSlug} />
}
